<template>
  <div>
    <CustomerRelationshipInput
      v-model="innerValue" />
  </div>
</template>
<script>
import CustomerRelationshipInput from '@components/input/CustomerRelationshipInput';
import { mapMutations } from 'vuex';

export default {
  name: 'CustomerRelationshipFilter',
  components: {
    CustomerRelationshipInput
  },
  props: {
    value: {
      type: String,
      required: true
    },
    field: {
      type: String,
      required: true
    }
  },
  computed: {
    innerValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
        this.setFilter({ key: this.field, value: val });
        if (val !== '') {
          this.$emit('filter', () => (x) => x.status === val);
        } else {
          this.$emit('filter', () => () => true);
        }
      }
    }
  },
  methods: {
    ...mapMutations({
      setFilter: 'dataTableFilters/setFilter'
    })
  },
  mounted() {
    this.innerValue = this.$store.state.dataTableFilters.filters[this.field] || this.value;
  }
};
</script>
<style>

</style>
